import EncampAutocomplete from "components/Forms/EncampAutocomplete";
import { TenantOption } from "../types";
import { SEARCH_TENANTS_QUERY } from "../queries";

interface TenantRuleFieldsProps {
  selectedTenant: TenantOption | null;
  tenantSearchVariables: {
    search: string;
    pageSize: number;
    sort: { field: string; sort: "asc" | "desc" }[];
  };
  onTenantChange: (tenant: TenantOption | null) => void;
  onInputChange: (value: string) => void;
}

/**
 * Field component for tenant-based rules (Deny Tenant)
 */
export function TenantRuleFields({
  selectedTenant,
  tenantSearchVariables,
  onTenantChange,
  onInputChange,
}: TenantRuleFieldsProps) {
  return (
    <EncampAutocomplete
      query={SEARCH_TENANTS_QUERY}
      getItems={(data) => data?.tenants.items ?? []}
      getOptionLabel={(option) => option.name}
      variables={tenantSearchVariables}
      value={selectedTenant}
      onChange={onTenantChange}
      onInputChange={onInputChange}
      label="Organization"
      hideErrors
    />
  );
}
